<template>
<div class="bg-fff" style="width: 80%;margin: 0 auto">
  <div class="flex flex-between flex-align-center global-padd">
    <div class="font-18 font-bold">添加活动</div>
<!--    <div>-->
<!--      <el-button type="primary" size="small" @click="dialogVisible=true">-->
<!--        <i class="el-icon-plus" style="margin-right: 5px"></i>添加用户-->
<!--      </el-button>-->
<!--    </div>-->
  </div>
  <div class="global-line margin-bottom-20"></div>
  <div class="global-padd-15">
    <el-form v-model="form2" label-width="150px">
      <el-form-item label="活动类型：">
        <el-select size="small"
                   clearable
                   style="width: 180px"
                   v-model="form2.noticeType">
          <el-option label="赛事活动" :value="1" ></el-option>
          <el-option label="课程训练" :value="2" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="封面：" >
        <div class="flex" style="align-items: flex-end">
          <img-Upload :url="logo" :showFileList="false" @getUrl="getLogo"></img-Upload>
          <span style="margin-left: 10px" class="font-warning font-14">（建议上传尺寸：698x240，对等比例的图片）</span>
        </div>

      </el-form-item>
      <el-form-item label="主题：" >
        <el-input size="small"
                  style="width: 500px"
                  clearable
                  v-model="form2.noticeTitle"
                  placeholder="请输入主题">
        </el-input>
      </el-form-item>
      <el-form-item label="活动详情：">
        <VueUeditorWrap :config="myConfig" v-model="form2.noticeContent"/>
      </el-form-item>

    </el-form>
    <div style="text-align: right">
      <el-button @click="$router.go(-1)">取消</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
  </div>

</div>
</template>

<script>
import imgUpload from '@/components/EeUpload'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  name: "create",
  components: {
    imgUpload,VueUeditorWrap
  },
  data(){
    return {
      VueUeditorWrapRef:'',
      logo:'',
      form2:{
        noticeType:1,
        noticeTitle:''
      },
      myConfig: {
        // div转p标签
        allowDivTransToP:false,
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 350,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 获取配置、上传图片的后台服务地址
        serverUrl: process.env.NODE_ENV === 'production'?'/api/rest/my/oss/policy':'/tf/rest/my/oss/policy',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: process.env.NODE_ENV === 'test'?'/tfweb/static/UEditor/':'/static/UEditor/',
        // UEDITOR_HOME_URL: '/static/UEditor/',
        // headers: {
        //   'zzb-access-token': localStorage.getItem('_$_zzb-access-token'),
        //   'host':'tf-member.oss-cn-hangzhou.aliyuncs.com'
        // }
      }
    }
  },
  destroyed() {
    if(this.VueUeditorWrapRef){
      clearInterval(this.VueUeditorWrapRef)
    }
  },
  mounted() {
    if(this.$route.params.id){
      this.getDetail()
    }
    const loading =this.$loading({
      text:"富文本编辑器加载中..."
    })
    this.VueUeditorWrapRef= setInterval(()=>{
      // console.log("asdas")
      if(document.querySelector('.edui-default')){
        loading.close()
        clearInterval(this.VueUeditorWrapRef)
      }
    },500)
  },
  methods:{
    getDetail(){
      this.$http.post('/rest/notice/detail', {noticeId:this.$route.params.id}, res => {
        this.logo=res.noticeCover
        this.form2=res
      })
    },
    getLogo(a){
      console.log(a)
      this.form2.noticeCover=a
    },
    submit(){
      this.$http.post('/rest/notice/publish', this.form2, res => {
        this.$message.success('保存完成！')
        this.$router.push('/activity')
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/activity/create.vue